module.exports = __webpack_public_path__ + "static/media/homepage_popup_Jclub_X_Pragmatic.23e246d3.png";